import React from 'react';
import { Col, Row } from 'reactstrap';
import { SkeletonTable } from '../../../../../../Components/Common/Skeleton';
import OfferTable from '../Components/OfferTable';
import TenderNotClosedAlert from '../Components/TenderNotClosedAlert';
import {
  canAccessEvaluationOperationalData,
  getEvaluationOperationalLockReason,
} from '../../../../utils/tenderEvaluationHelpers';

const TabOffer = ({
  procurement,
  procId,
  isLoadingProcurement,
  parcels = [],
  isLoadingParcels = false,
  onSelectedOffersChange,
  selectionClearToken = 0,
  isActive = true,
  selectionDisabled = false,
}) => {
  if (isLoadingProcurement && !procurement) {
    return <SkeletonTable rows={5} columns={6} />;
  }

  const lockReason = getEvaluationOperationalLockReason(procurement);
  const canAccessData = canAccessEvaluationOperationalData(procurement);

  return (
    <div>
      <div className='mb-3'>
        <h5 className='fw-bold text-dark mb-1'>Offer Detail</h5>
        <p className='text-muted small mb-0'>
          {selectionDisabled
            ? 'Evaluation is locked. Offer data is read-only.'
            : 'Bandingkan penawaran mitra per requirement. Pilih offer (atau Select all offers) lalu kirim Request Improvement.'}
        </p>
      </div>

      {!canAccessData ? (
        <TenderNotClosedAlert featureLabel='Offer' reason={lockReason} />
      ) : (
        <Row>
          <Col md={12}>
            <OfferTable
              procurementId={procurement?.id || procId}
              procurement={procurement}
              parcels={parcels}
              isLoadingParcels={isLoadingParcels}
              onSelectedOffersChange={onSelectedOffersChange}
              selectionClearToken={selectionClearToken}
              isActive={isActive}
              selectionDisabled={selectionDisabled}
            />
          </Col>
        </Row>
      )}
    </div>
  );
};

export default TabOffer;
